<template>
  <div id="app">
    <div id="main" >
      <b-navbar toggleable="md" type="dark" fixed="top" class="noprint justify-content-between">

        <b-navbar-brand href="https://gainesville.bosshardtrealty.com"><img src="@/assets/logo.png"></b-navbar-brand>

        <b-button v-if="favorites.length > 1" v-on:click="printList" class="ml-auto d-none d-lg-block border border-light nav-button">
          {{ printing ? 'Close Print View' : (favorites.length ? 'Print Favorites' : 'Show Printable List') }}
        </b-button>
        
        <b-button v-on:click="toggle" class="ml-1 d-lg-none border border-light nav-button" v-if="!printing">
          {{ showMap ? 'Show List' : 'Show Map' }}
        </b-button>
                
      </b-navbar>
      <b-modal v-if="new Date(blitzDate).getTime() > new Date().getTime() - 172800000" ref="modal" class="text-center" style="color: black;" size="lg" v-model="showModal" centered hide-header ok-title="Take a look" ok-variant="bosshardt" ok-only>
        <h2>Welcome to the Bosshardt Realty Services</h2>
        <h3><em>Open House Blitz</em></h3>
        <br>
        <h6>See the best listings on one great day...</h6>
        <p>We are pleased to announce Gainesville's largest one-day open house event - The Bosshardt Open House Blitz. On {{blitzDate}} dozens of homes will host hundreds of buyers across Gainesville, Newberry, Alachua, and the rest of Alachua County from 12:00-4:30PM.</p>
      </b-modal>
      <b-modal v-if="new Date(blitzDate).getTime() <= new Date().getTime() - 172800000" ref="modal" class="text-center" style="color: black;" size="lg" v-model="showModal" centered hide-header hide-footer no-close-on-esc no-close-on-backdrop>
        <h2>Welcome to the Bosshardt Realty Services</h2>
        <h3><em>Open House Blitz</em></h3>
        <br>
        <p>Our last Open House Blitz was on {{blitzDate}}. Check back here to find out when our next one will be! In the meantime, our agents host open houses almost every weekend, take a look at the one's going on now!</p>
        <br>
        <a class="btn btn-bosshardt" href="https://gainesville.bosshardtrealty.com/results/?feature=OH&userid=all">View our current listings</a>
        <br>
        <br>
        <p><small>Please note that any information shown on the background of this page is from our previous Blitz and may no longer be accurate, click the button above for current information</small></p>
      </b-modal>
      <div class="content" v-if="!printing">
        <div id="mapControl" v-on:click="clearFilter">
          <div>Show All</div>
        </div>
        <div id="showFavorites" v-on:click="setFilter">
          <div>Show Favorites</div>
        </div>
        <div v-bind:class="{showing: showMap}" class="split map-container">
          <google-map name="blitz" 
                      v-bind:showing="showMap" 
                      v-bind:listingdata="listings" 
                      v-bind:filter="showMarkers"
                      ></google-map>
        </div>
        <div v-bind:class="{showing: showList}" class="split listing-col">
          <listing v-for="listing in listings"
                    v-bind:info="listing"
                    v-bind:key="listing.HN"
                    v-bind:favs="favorites"
                    :id="listing.HN"
                    v-on:favorite="addFavorite"
                    v-on:showOnMap="filterMap">
          </listing>
        </div>
      </div>
    </div>
    <div id="print" v-if="printing">
      <print-list v-for="listing in listings"
                    v-bind:info="listing"
                    v-bind:key="listing.HN"
                    :id="listing.HN"
                    v-if="!favorites.length || favorites.includes(listing.HN)">
      </print-list>
    </div>

  </div>
</template>

<script>
import Listing from './components/Listing'
import GoogleMap from './components/GoogleMap'
import PrintList from './components/PrintList'

export default {
  name: 'app',
  components: {
    Listing,
    GoogleMap,
    PrintList
  },
  data: function () {
    return {
      listings: listingArray,
      blitzDate: blitzTime,
      showMap: true,
      showList: false,
      printing: false,
      favorites: document.cookie.replace(/(?:(?:^|.*;\s*)faves\s*=\s*([^;]*).*$)|^.*$/, '$1').split('|') || [],
      showMarkers: null,
      showModal: true
    }
  },
  methods: {
    toggle: function () {
      this.showMap = !this.showMap
      this.showList = !this.showList
    },
    printList: function () {
      this.printing = !this.printing
      this.printing ? document.body.style.overflow = 'auto' : document.body.style.overflow = 'hidden'
    },
    addFavorite: function (e) {
      if (this.favorites.includes(e.id)) {
        this.favorites.splice(this.favorites.indexOf(e.id), 1)
      } else {
        this.favorites.push(e.id)
      }
      let favcookie = 'faves=' + this.favorites.join('|') + ';max-age=604800'
      document.cookie = favcookie
    },
    filterMap: function (e) {
      this.toggle()
      this.showMarkers = [e.id]
      console.log(e.id)
    },
    clearFilter: function () {
      this.showMarkers = []
    },
    setFilter: function () {
      this.showMarkers = this.favorites
    },
    closeModal: function () {
      document.querySelector('.modal').style.display = none
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
}

.btn-bosshardt {
  background-color: #991B31;
  color: white;
}
.btn-bosshardt:hover{
  color: white;
}

#mapControl, #showFavorites {
  cursor: pointer;
  float: left;
  position: relative;
  margin-top: 10px;
  margin-right: 10px;
}

#mapControl > div:hover, #showFavorites > div:hover {
  background-color: rgb(235, 235, 235);
  color: black;
}

#titleDiv {
  color: #991B31;
  margin-top: 10px;
  padding: 10px;
  text-shadow: 1px 1px 1px #991B31;
}

#mapControl > div {
  direction: ltr;
  overflow: hidden;
  text-align: center;
  position: relative;
  color: rgb(86, 86, 86);
  font-family: Roboto, Arial, sans-serif;
  user-select: none;
  font-size: 11px;
  background-color: rgb(255, 255, 255);
  padding: 8px;
  border-radius: 2px;
  background-clip: padding-box;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  min-width: 39px;
  border-left: 0px;
}
#showFavorites > div {
  direction: ltr;
  overflow: hidden;
  text-align: center;
  position: relative;
  color: rgb(86, 86, 86);
  font-family: Roboto, Arial, sans-serif;
  user-select: none;
  font-size: 11px;
  background-color: rgb(255, 255, 255);
  padding: 8px;
  border-radius: 2px;
  background-clip: padding-box;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  min-width: 39px;
  border-left: 0px;
}

.nav-button, .nav-button:hover, .nav-button:active, .nav-button:focus {
  background: none!important;
  outline: none;
  box-shadow: none;
}

.navbar {
  background-color: #991B31;
  border-bottom: 1px solid #ccc;
  box-shadow: 0 1px 4px rgba(0,0,0,.15);
}

.listing-card {
  min-height: 220px;
  height: 22vh;
  margin-top: 5px;
}

.navbar img {
  max-height: 40px;
}

html, body {
  padding: 0;
  margin: 0;
  height:100%;
  overflow: hidden;
}

.map-container {
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 65%;
}
.content {
  position: absolute;
  top: 66px;
  left: 0;
  right: 0;
  bottom: 0;
}
.listing-col {
  box-shadow: -2px -1px 5px 0 rgba(0,0,0,.4);
  position: absolute;
  top: 0px;
  right: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-flow: column;
  padding: 5px 5px 71px 5px;
  height: 100%;
  width: 35%;
}

.highlight {
  border: 1px solid #991B31!important;
  box-shadow: 0px 0px 3px 3px rgb(153,27,49)!important;
}

@media only screen and (max-width: 991px) {
  .showing {
    width: 100%;
    display: flex!important;
  }
  .listing-col {
    display: none;
  }
  .map-container {
    display: none;
  }
  #mapControl > div, #showFavorites > div {
    padding-top: 11px;
    padding-bottom: 11px;
    padding-right: 11px;
  }
  #mapControl > div {
    padding-left: 11px;
  }
}

#print {
  margin-top: 76px;
}

@media print {
  .noprint {
    display: none;
  }

  #print {
    margin-top: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue